<script setup lang="ts">
import { useOnTimezoneChange } from '@entities/viewer'

import { useDisciplineRefresh } from '../model/discipline-refresh.hook'
import DisciplinePageLoader from './DisciplinePageLoader.vue'
import DisciplineActivation from './DisciplineActivation.vue'

defineOptions({
  name: 'DisciplineActivationPage',
})

const { refreshDiscipline } = useDisciplineRefresh()

useOnTimezoneChange(() => {
  void refreshDiscipline()
})
</script>

<template>
  <DisciplinePageLoader />
  <DisciplineActivation />
</template>
